export default __webpack_public_path__ + "static/5-0cda7228a6ab24f3f1f5572beb19aead.jpg";